module.exports = __webpack_public_path__ + "static/media/49f37cfb.jpg";